import { ImageField, KeyTextField } from '@prismicio/client';
import { PrismicNextImage } from '@prismicio/next';
import styles from './TransparentLabel.module.scss';

interface Props {
  text: KeyTextField;
  icon: ImageField;
  isAligned?: boolean;
}

const TransparentLabel = ({ text, isAligned = true, icon }: Props) => {
  return (
    <div className={`${styles.wrapper} ${!isAligned ? styles.notAligned : ''}`}>
      <PrismicNextImage className={styles.icon} field={icon} />
      <span className={styles.text}>{text}</span>
    </div>
  );
};

export default TransparentLabel;
